import { validate as isValidUUID } from 'uuid';
import { NotificationScope } from '@/libs/common/model/NotificationScope';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';

class ActiveModeService {
    public getActiveWorkplaces(): string[] {
        const isSharedMode = authStore.useGetter(AuthGetter.GetSharedMode) ?? false;
        const isNotificationMode = authStore.useGetter(AuthGetter.GetNotificationMode) ?? false;
        if (isSharedMode) {
            return this.getStoredActiveWorkplaces();
        } else if (isNotificationMode) {
            return this.getStoredNotificationScope()?.workplaces ?? [];
        }
        return [];
    }

    public getActiveStations(): string[] {
        const isSharedMode = authStore.useGetter(AuthGetter.GetSharedMode) ?? false;
        const isNotificationMode = authStore.useGetter(AuthGetter.GetNotificationMode) ?? false;
        if (isSharedMode) {
            return this.getStoredActiveStations();
        } else if (isNotificationMode) {
            return this.getStoredNotificationScope()?.stations ?? [];
        }
        return [];
    }

    public getActiveLocations(): string[] {
        const isNotificationMode = authStore.useGetter(AuthGetter.GetNotificationMode) ?? false;
        if (isNotificationMode) {
            return this.getStoredNotificationScope()?.locations ?? [];
        }
        return [];
    }

    public getStoredActiveWorkplaces(): string[] {
        const activeWorkplace = window.localStorage.ActiveWorkplace;
        let isValidGuid = false;
        try {
            isValidGuid = isValidUUID(activeWorkplace);
        } catch (e) {
            // ts-ignore
        }
        if (isValidGuid) {
            return [window.localStorage.ActiveWorkplace];
        } else {
            try {
                const activeWorkplaces = JSON.parse(window.localStorage.ActiveWorkplace) as string[];
                return activeWorkplaces ?? [];
            } catch (e) {
                return [];
            }
        }
    }

    public getStoredActiveStations(): string[] {
        try {
            const activeStations = JSON.parse(window.localStorage.ActiveStation) as string[];
            return activeStations ?? [];
        } catch (e) {
            return [];
        }
    }

    public getStoredNotificationScope(): NotificationScope | null {
        try {
            return (JSON.parse(window.localStorage.NotificationScope) as NotificationScope) ?? null;
        } catch (e) {
            return null;
        }
    }
}

export default new ActiveModeService();
